import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';

import {
  AbsenceTypeGroupsSettings,
  GetAccountWidgetAbsencesResponse,
  UpdateWidgetAbsencesRequest,
  WidgetAbsencesEmployeeSettings,
  WidgetAbsencesManagerSettings,
} from '@app/gen/dashboard';

import { AbsencesFormValues } from '../../../pages/Company/CompanyAbsencesSettings/types';

@injectable()
export class SettingsAbsencesMapper {
  constructor(private format: FormatService) {}

  private processSettingsToInitialValues(
    absencesSettings?:
      | AbsenceTypeGroupsSettings
      | WidgetAbsencesEmployeeSettings
      | WidgetAbsencesManagerSettings,
  ): Record<string, string> {
    if (!absencesSettings) return {};

    return Object.fromEntries(
      Object.entries(absencesSettings ?? {}).map(([key, value]) => [
        key,
        this.processValueToString(value),
      ]),
    );
  }

  private processValueToString(value: boolean | string | undefined): string {
    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }

    return String(value ?? '');
  }

  private processValuesToSettings(
    values: Record<string, string>,
  ): Record<string, boolean | string> {
    return Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        key === 'parent_units_managers_option'
          ? value
          : this.format.toBoolean(value),
      ]),
    );
  }

  processAbsencesSettings(
    absencesSettings: GetAccountWidgetAbsencesResponse,
  ): AbsencesFormValues {
    return {
      absence_type_groups: this.processSettingsToInitialValues(
        absencesSettings.absence_type_groups,
      ),
      employee_settings: this.processSettingsToInitialValues(
        absencesSettings.employee_settings,
      ),
      manager_settings: this.processSettingsToInitialValues(
        absencesSettings.manager_settings,
      ),
    };
  }

  processAbsencesSettingsValues(
    values: AbsencesFormValues,
  ): UpdateWidgetAbsencesRequest {
    return {
      absence_type_groups: this.processValuesToSettings(
        values.absence_type_groups,
      ),
      employee_settings: this.processValuesToSettings(values.employee_settings),
      manager_settings: this.processValuesToSettings(values.manager_settings),
    };
  }
}
